import React from 'react';

import { Theme, createStyles, withStyles, TextField } from '@material-ui/core';

import style from '../commonComponentsStyle.module.css';
import commonStyles from '../../common/common.module.css';
import PickupOrder from '../../../models/PickupOrder';

const TEXT_FIELD_PADDINGS: string = '8px 12px';
const iconFontSize = 40;
const useStyles = (theme: Theme) =>
  createStyles({
    materialIcon: {
      fontSize: iconFontSize,
      '&:hover': {
        cursor: 'pointer',
      },
    },
    textWrapper: {
      marginTop: '2%',
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%'
    },
    wrapper: {
      marginTop: '2%',
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      flexDirection: 'column',
      alignItems: 'center'
    },
    formControl: {
      width: '79%',
      marginLeft: '8.5%',
      marginRight: '10px',
      marginTop: '5px',
    },
    formControlFWd: {
      width: '86%',
    },
    label: {
      minWidth: '355px',
    },
    companyText: {
      width: '100%',
    },
    styleInputProps: {
      color: 'var(--primaryblue)',
      fontSize: '0.8125rem',
    },
    helperText: {
      color: 'red',
      marginLeft: '10px',
    },
  });

interface CompanyDropDownProps {
  classes: any;
  pickupOrder: PickupOrder;
  handleChange: Function;
  handleClick: Function;
  maskOn: Function;
}

const companyDropDown = (props: CompanyDropDownProps) => {
  const { classes } = props;

  return (
    <div className={ classes.wrapper }>
      <div className={ commonStyles.inputLabelWrapper }>
        <label className={ commonStyles.inputLabel }>Trucking Company *</label>
        <TextField
          className={[classes.widthWrapper, classes.companyText].join(' ')}
          variant='outlined'
          value={props.pickupOrder.delivery_company_name}
          onChange={(event) => props.handleChange('company', event)}
          inputProps={{ style: { padding: TEXT_FIELD_PADDINGS } }}
          InputLabelProps={{ shrink: true }}
        />
      </div>
    
      <div className={[style.flex, classes.textWrapper, style.dInfoWrapper].join(' ')}>
        <div className={ commonStyles.inputLabelWrapper }>
          <label className={ commonStyles.inputLabel }>Driver's License</label>
          <TextField
            className={[classes.textField45, classes.textField].join(' ')}
            variant='outlined'
            onClick={ () => props.handleClick('license') }
            onBlur={ () => props.maskOn() }
            value={props.pickupOrder.maskedDriverId}
            onChange={(event) => props.handleChange('license', event)}
            inputProps={{ style: { padding: TEXT_FIELD_PADDINGS } }}
            InputLabelProps={{ shrink: true }}
          />
        </div>
            
        <div className={ commonStyles.inputLabelWrapper }>
          <label className={ commonStyles.inputLabel }>Truck Plate</label>
          <TextField
            className={[classes.textField45, classes.textField].join(' ')}
            variant='outlined'
            value={props.pickupOrder.driver_vehichle_registration}
            onChange={(event) => props.handleChange('plate', event)}
            inputProps={{ style: { padding: TEXT_FIELD_PADDINGS } }}
            InputLabelProps={{ shrink: true }}
          />
        </div>
            
      </div>
    </div>
  );
};



export default withStyles(useStyles)(companyDropDown);
